<template>
  <v-footer
      :color="get_interface.colors.footer"
      app
      :absolute="!is_mobile"
      :fixed="is_mobile"
      class="footer"
      :class="{ mobile: is_mobile }"
    >
    <v-dialog
      v-model="about"
      max-width="790"
      content-class="about-dialog"
    >
      <div class="about-content">
        <div class="solaris"></div>
        <div class="logo"></div>
        <!-- <div class="logo-shine2">
          <div class="logo1" />
          <div class="logo2" />
          <div class="shine" />
        </div> -->
        <div class="copyright">
          {{ `Solaris ${app_data.title} (${app_data.edition}) ${app_data.ver} - Desenvolvido por Solaris Web © ${new Date().getFullYear()}` }}
        </div>
      </div>
    </v-dialog>
    <template v-if="get_interface.loading">
      <v-progress-linear
        :color="get_interface.colors.loading"
        indeterminate
        height="36"
        app
        light
        fixed
        striped
        buffer-value="500"
        class="loading-bar"
      ></v-progress-linear>
      <div class="loading-icon">
        <v-icon>{{ loading_icon }}</v-icon>
      </div>
    </template>
    <div class="dev-bar">
      <div class="customer-logo">
        <v-img
          src="../../assets/mini-logo.png"
          lazy-src="../../assets/mini-logo.png"
          aspect-ratio="1"
          height="20"
          class="cst-logo"
        />
      </div>
      <div
        @click="about = true"
        class="app-logos"
      >
        <v-img
          src="../../assets/sun_2020.png"
          lazy-src="../../assets/sun_2020.png"
          aspect-ratio="1"
          width="25"
          class="dev-logo"
        />
        <div class="app-logo"></div>
      </div>
    </div>
    </v-footer>
</template>

<script>
import appdata from '@/mixins/appdata'

export default {
  mixins: [ appdata ],
  data: () => ({
    about: false,
    loadingIcon: {
      count: 0,
      interval: null
    }
  }),
  computed: {
    loading_icon: function () {
      let count = this.loadingIcon.count
      return (count === 0 ? 'mdi-hexagon-outline' : 'mdi-hexagon-slice-' + count)
    }
  },
  watch: {
    'get_interface.loading': function (newVal) {
      if (newVal) {
        this.loadingIcon.interval = setInterval(() => {
          let count = this.loadingIcon.count
          this.loadingIcon.count = (count > 5 ? 0 : parseInt(count) + 1)
        }, 355)
      } else {
        clearInterval(this.loadingIcon.interval)
        this.loadingIcon.interval = null
      }
    }
  },
  destroyed() {
    if (this.loadingIcon.interval) {
      clearInterval(this.loadingIcon.interval)
      this.loadingIcon.interval = null
    }
  }
}
</script>

<style src="@/styles/main/footer.scss" lang="scss"></style>
<style lang="scss">
.customer-logo {
  width: 225px !important;
  height: 70px !important;
  float: left;
  margin: 0px !important;
  position: absolute;
  .cst-logo {
    width: 147px;
    height: 25px !important;
    margin-top: 5px;
    margin-left: 5px;
    filter: brightness(105%);
  }
}
</style>